export const useCalculaPorcentagem = () => {
  const useCalculaPorcentagemDoisArgumentos = (preenchidos: number, total: number): string => {
    return ((preenchidos / total) * 100).toFixed(2);
  };

  return {
    useCalculaPorcentagemDoisArgumentos,
  };
};
